import { render, staticRenderFns } from "./TableItem.vue?vue&type=template&id=3025e905&scoped=true"
import script from "./TableItem.vue?vue&type=script&lang=js"
export * from "./TableItem.vue?vue&type=script&lang=js"
import style0 from "./TableItem.vue?vue&type=style&index=0&id=3025e905&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3025e905",
  null
  
)

export default component.exports